<template>
  <div class="edit-profile-container">
    <error :errors="errors" />
    <b-overlay :show="busy" rounded="sm">
    <portlet title="ئارخىب تەھرىرلەش">
      <template slot="body">
        <b-form @submit.stop.prevent="onSubmit">
          <b-form-group id="fieldset-3" description="باش سۆرەت تاللاپ ئالماشتۇرۇڭ" label="باش سۆرەت" >
            <avatar-uploader :image-url="avatarUrl" :preview-url="previewUrl" :upload-success="onUploadSuccess" @cancel="cancelUploadAvatar" />
          </b-form-group>
          <div class="row">
            <div class="col-md-6">
              <b-form-group :state="validateState('nickname')" aria-describedby="nickname-live-feedback" id="fieldset-1" description="يېڭى تور نامىڭىزنى كىرگۈزۈڭ" label="تور نامىڭىز" label-for="nickname">
                <b-form-input :placeholder="currentUser.nickname" v-model="user.nickname" id="nickname" trim></b-form-input>
                <b-form-invalid-feedback id="nickname-live-feedback">
                  تور نامىڭىز كەم دىگەندە ئئككى ھەرىپتىن ئاز بولمىسۇن
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group id="fieldset-2" :state="validateState('phone')" aria-describedby="phone-live-feedback" description="تېلفۇن نۇمۇرىڭىز كىرگۈزۈڭ" label=" تېلفۇن نۇمۇرىڭىز " label-for="phone">
                <b-form-input :placeholder="currentUser.phone" v-model="user.phone" id="phone" trim></b-form-input>
                <b-form-invalid-feedback id="phone-live-feedback">
                  تېلفۇن نۇمۇرىڭىزنى توغرا تولدۇرۇڭ
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
          <b-button id="submit" type="submit" variant="primary">
            ساقلاش
          </b-button>
          <b-button class="ml-2" type="reset" variant="danger">
            بىكار قىلىش
          </b-button>
        </b-form>
      </template>
    </portlet>
    </b-overlay>
  </div>
</template>

<script>
  import Portlet from "../../../partials/content/Portlet";
  import AvatarUploader from "../../../partials/layout/AvatarUploader";
  import Error from "../../../partials/widgets/Error";
  import { mapGetters, mapState } from "vuex";
  import { validationMixin } from "vuelidate";
  import { minLength } from "vuelidate/lib/validators";
  import { regex } from 'vuelidate/lib/validators/common'
  import {UPDATE_ADMIN, UPDATE_USER} from "../../../../store/auth.module";
  import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
  const phone = regex('phoneNumber', /^1(3|4|5|7|8)\d{9}$/);
  export default {
    name: "index",
    mixins: [validationMixin],
    validations: {
      formData: {
        nickname: { minLength: minLength(2) },
        phone: { phone }
      }
    },
    components: { Portlet, AvatarUploader, Error },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "ئارخىب باشقۇرۇش", route: "/profile" },
        { title: "ئارخىب تەھرىرلەش" }
      ]);
    },
    computed: {
      ...mapGetters(['currentUser']),
      ...mapState({
        errors: state => state.auth.errors
      }),
      avatarUrl: {
        get(){
          return this.user.avatar ? this.user.avatar : this.currentUser.avatar;
        },
        set(v){
          this.user.avatar = v;
          return v;
        },
      },
      previewUrl: {
        get(){
          return this.preview ? this.preview : this.currentUser.avatar_url;
        },
        set(v){
          this.preview = v;
          return v;
        },
      }
    },
    data(){
      return {
        user: {
          nickname: '',
          phone: '',
          avatar: '',
        },
        preview: '',
        busy: false
      };
    },
    methods: {
      onUploadSuccess(info){
        this.avatarUrl = info.path;
        this.previewUrl = info.url;
      },
      cancelUploadAvatar(info){
        this.avatarUrl = info.oldImage;
        this.previewUrl = info.oldPreview;
      },
      onSubmit(){
        this.$v.formData.$touch();
        if (this.$v.formData.$anyError) {
          this.$bvToast.toast('ئ‍ەسكەرتىشكە دېققەت قىلىڭ', {
            title: "ئەسكەرتىش",
            variant: "error",
            toaster: "b-toaster-top-center"
          });
          return;
        }
        this.submitState();
        this.busy = true;
        this.$store.dispatch(UPDATE_ADMIN, this.user)
          .then(()=>{
            this.submitState(false);
            this.busy = false;
            this.$bvToast.toast('ئارخىبىڭىز تەھرىرلەندى .', {
              title: "ئەسكەرتىش",
              variant: "default",
              toaster: "b-toaster-top-center"
            });
          })
          .catch(()=>{this.busy = false; this.submitState(false);})
      },
      submitState(action = true){
        let submitBtn = document.getElementById("submit");
        if ( action ){
          submitBtn.classList.add(
            "kt-spinner",
            "kt-spinner--light",
            "kt-spinner--right"
          );
        }else {
          submitBtn.classList.remove(
            "kt-spinner",
            "kt-spinner--light",
            "kt-spinner--right"
          );
        }
      },
      validateState(name, parent = null) {
        if ( parent ){
          const { $dirty, $error } = this.$v.formData[parent][name];
          return $dirty ? !$error : null;
        }
        const { $dirty, $error } = this.$v.formData[name];
        return $dirty ? !$error : null;
      },
    }
  }
</script>

<style scoped>

</style>
